import { BaseControl, Flex, FlexBlock } from '@wordpress/components';
import TextControl from './TextControl';

const LinkButton = ({ field, value = {}, onChange }) => {
    const handleTextChange = (text) => {
        onChange({ ...value, text });
    };

    const handleUrlChange = (url) => {
        onChange({ ...value, url });
    };

    return (
        <BaseControl label={field.label} __nextHasNoMarginBottom>
            <Flex gap={2} wrap>
                <FlexBlock>
                    <TextControl
                        field={{ label: 'Text', type: 'text' }}
                        value={value.text || ''}
                        onChange={handleTextChange}
                    />
                </FlexBlock>
                <FlexBlock>
                    <TextControl
                        field={{ label: 'URL', type: 'url' }}
                        value={value.url || ''}
                        onChange={handleUrlChange}
                    />
                </FlexBlock>
            </Flex>
        </BaseControl>
    );
};

export default LinkButton;
